import { render, staticRenderFns } from "./EscalaFolgas.vue?vue&type=template&id=a3700d64&scoped=true&"
import script from "./EscalaFolgas.vue?vue&type=script&lang=js&"
export * from "./EscalaFolgas.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./EscalaFolgas.vue?vue&type=style&index=1&id=a3700d64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3700d64",
  null
  
)

export default component.exports